<template>
    <div class="container padding-top">
        <div>
            <h2>{{ detail.title }}</h2>
            <div class="stitle">
                <span class="booklink" @click="jumptoweb" v-if="detail.authorwareTypeName">点击收听：《{{detail.bookName}}》</span> 来源：{{ detail.platformName }}  <span v-if="detail.putOnTime"> 发布时间：{{detail.putOnTime}} </span>
            </div>
            <div v-html="detail.content"></div>
            <div class="more">
                <button v-if="detail.authorwareTypeName" @click="jumptoweb" >更多精彩内容，点击收听本书</button>
            </div>
            
        </div>
    </div>
</template>

<script>
import { getCookie } from '@/network/cookie.js'

export default {
    metaInfo() {
        return {
            title: "路上畅听" + this.$store.state.title,
            meta: [
                {
                    vmid: "keywords",
                    name: "keywords",
                    content: this.$store.state.keywords,
                },
                {
                    vmid: "description",
                    name: "description",
                    content: this.$store.state.description,
                },
            ],
        };
    },
    data() {
        return {
            detail: {},
            id: this.$route.query.id,
            sessionId: getCookie('sessionId')
        };
    },
    methods: {
        getNewsDetail: function () {
            this.$http.get({
                url: '/xcx/new-book-information!bookDetail' + '?id=' + this.id + '&sessionId=' + this.sessionId
            }).then(res => {
                this.detail = res.data.data;

            })
        },
        jumptoweb:function(){
            if(this.detail.authorwareType == '0' || this.detail.authorwareTypeName==='书'){
                this.$router.push({
                    path: 'bookdetail',
                    query:{bookId:this.detail.authorwareId}
                })
            }
            if(this.detail.authorwareType == '1' || this.detail.authorwareTypeName==='书单'){
                this.$router.push({
                    path: 'booklist',
                    query:{listId:this.detail.authorwareId}
                })
            }
        }
    },
    watch: {
        $route() {
            this.id = this.$route.query.id;
            this.getNewsDetail();
        },
    },
    mounted() {
        if (this.$route.query.id) {
            this.id = this.$route.query.id;
        }
        this.getNewsDetail()
    }
};
</script>

<style scoped>
.title {
    font-family: PingFangSCHeavy;
    font-size: 14px;
    font-weight: 600;
}
h2{
    text-align: center;
}
.pointer {
    cursor: pointer;
}

.pointer:hover {
    color: #42b983;
}

a {
    text-decoration: none;
}

.padding-top {
    padding-top: 50px;
}
  
.stitle {
    text-align: center;
    font-size: 14px;
    color: #666;
    padding: 10px;
    border-top: 1px solid #f1f1f1;
    border-bottom: 1px solid #f1f1f1;
}
.booklink{
    color: #42b983;
    cursor: pointer;
    margin-right: 10px;
}

.more {
    clear: both;
    text-align: center;
    padding: 30px 0;
}

.more button {
    color: rgba(75, 204, 170, 1);
    background: none;
    padding: 5px 10px;
    border: 1px solid rgba(75, 204, 170, 1);
    border-radius: 3px;
    cursor: pointer;
}

.more button:hover {
    background: #4bcdab;
    color: #fff;
}
</style>
